import React from 'react';
import { useHistory } from 'react-router-dom';
import constants from '../../../../../../core/constants';
import Frame from '../../../../../components/Frame';
import useProfile from '../../../../../hooks/useProfile';
import { BackButton } from '../../../components/Buttons';
import { ProcedureWrapper } from '../../../styled';

const ProceduresCreatedEmbeddedView = () => {
  const { push } = useHistory<any>();
  const { profile } = useProfile();

  return (
    <ProcedureWrapper gap data-testid="cmp-procedure-created-embedded">
      <BackButton
        onClick={() => {
          push('/tramites');
        }}
      />
      <Frame
        source={`${constants.PE_URL}${constants.PE_PATH_HISTORICO_TRAMITES}`}
        title="MyIframe"
      >
        <input type="hidden" name="codutpalu" value={profile.studentCode} />
      </Frame>
    </ProcedureWrapper>
  );
};

export default ProceduresCreatedEmbeddedView;
